(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/keno/views/pages/result-page.js') >= 0) return;  svs.modules.push('/modules/keno/views/pages/result-page.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.keno=_svs.keno||{};
_svs.keno.templates=_svs.keno.templates||{};
svs.keno.templates.result_page = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id=\"ngResultRegion\"></div>\n";
},"useData":true});
Handlebars.partials['svs-keno-result_page'] = svs.keno.templates.result_page;
})(svs, Handlebars);


 })(window);